const STORAGE_USER = "currentUser";

export const pushAuthUser = (user) => {
  localStorage.setItem(STORAGE_USER, JSON.stringify(user));
};
export const clearStoredAuthUser = () => {
  localStorage.removeItem(STORAGE_USER);
};
export const getStoredAuthUser = () => {
  const storedUser = JSON.parse(localStorage.getItem(STORAGE_USER));
  return storedUser;
};
